import { createSlice } from '@reduxjs/toolkit';

const dashcamSlice = createSlice({
  name: 'dashcam',
  initialState: {
    channels: [],
    devices: [],
    selectedDevice: null,
    gridLayout: 2,
    isLoading: false,
    errorMessage: null,
    isEnabled: true,
  },
  reducers: {
    selectDevice: (state, action) => {
      state.selectedDevice = action.payload.device;
      state.channels = action.payload.channels;
      state.errorMessage = null;
    },
    setGridLayout: (state, action) => {
      state.gridLayout = action.payload;
    },
    playChannel: (state, action) => {
      const channel = state.channels.find(ch => ch.id === action.payload);
      if (channel) {
        channel.isPlaying = true;
        channel.hasError = false;
        channel.playerState = 'playing';
      }
    },
    stopChannel: (state, action) => {
      const channel = state.channels.find(ch => ch.id === action.payload);
      if (channel) {
        channel.isPlaying = false;
        channel.playerState = 'stopped';
      }
    },
    toggleMute: (state, action) => {
      const channel = state.channels.find(ch => ch.id === action.payload);
      if (channel) {
        channel.isMuted = !channel.isMuted;
      }
    },
    updateChannelState: (state, action) => {
      const { channelId, playerState, errorMessage } = action.payload;
      const channel = state.channels.find(ch => ch.id === channelId);
      if (channel) {
        channel.playerState = playerState;
        channel.errorMessage = errorMessage;
        channel.hasError = playerState === 'error';
        channel.isPlaying = playerState === 'playing';
      }
    },
    setEnabled: (state, action) => {
      state.isEnabled = action.payload;
      if (!action.payload) {
        // Stop all channels when disabled
        state.channels.forEach(channel => {
          channel.isPlaying = false;
          channel.playerState = 'stopped';
        });
      }
    },
    setError: (state, action) => {
      state.errorMessage = action.payload;
    },
    clearError: (state) => {
      state.errorMessage = null;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  selectDevice,
  setGridLayout,
  playChannel,
  stopChannel,
  toggleMute,
  updateChannelState,
  setEnabled,
  setError,
  clearError,
  setLoading,
} = dashcamSlice.actions;

export default dashcamSlice.reducer;